const throwError = (text) => {
  throw new Error(`useLocalStorage: ${text}`)
}

export const useLocalStorage = (key, possibleValues = []) => {
  if (typeof key !== 'string') {
    throwError('Key MUST be string')
  }
  return new Proxy({}, {
    get() {
      if (process.server) {
        console.warn('You trying to use local storage get on server, key: ', key)
        return
      }
      return window.localStorage.getItem(key)
    },
    set(target, prop, value) {
      if (prop !== 'value') {
        throwError('You can use ONLY value property to access and edit data')
      }
      else if (possibleValues.length && !possibleValues.includes(value)) {
        throwError(`Value should be one of: ${possibleValues}`)
      }
      else {
        if (process.server) {
          console.warn('You trying to use local storage set on server, key: ', key)
          return
        }
        target.value = value
        window.localStorage.setItem(key, value)
        return true
      }
    },
  })
}

export const AuthBy = useLocalStorage('authBy', ['email', 'phone']) // use AuthBy.value
